import { ladderAccess } from '@church/data'
import { peopleReach } from '@church/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * The Teams tab's old address. Teams has gone from the Services sections
 * (docs/14): who serves is on People, and teams are managed in each
 * service type's settings. Old links land on People — or on Plans for
 * someone without a People page.
 */
export const Route = createFileRoute('/_authed/_shell/services/_sections/teams')({
  beforeLoad: ({ context }) => {
    const held = ladderAccess(context.me)
    const people = !held.servicesLocked && peopleReach(held.access) !== 'none'
    throw redirect({ to: people ? '/services/people' : '/services/plans', replace: true })
  },
})
